import React from 'react';
import styled from 'styled-components';

import color from '../theme';

const ImageBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${props => props.imageRight && 'flex-direction: row-reverse;'};

  align-items: center;
  justify-content: center;
  margin: 30px auto;

  & li {
    padding: 4px;
  }

  & ul {
    list-style: none;
  }

  & li::before {
    content: '•';
    color: ${color};
    font-size: larger;
    width: 20px;
    margin-left: -20px;
    display: inline-block;
  }
`;

const ImageText = styled.div`
  max-width: 400px;
  min-width: 300px;
  flex: 5 5 300px;
`;
const ImageImage = styled.div`
  height: 100%;
  flex: 1 1 50px;
  max-width: ${props => (props.small ? 100 : 300)}px;
  margin: 1em;
`;

export default ({ children, Illustration, imageLeft, small }) => (
  <ImageBox imageRight={!imageLeft}>
    <ImageImage small={small}>
      <Illustration />
    </ImageImage>
    <ImageText>{children}</ImageText>
  </ImageBox>
);
